import {
  StarOutlined,
  FileTextOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import styles from "./SegmentGroup.module.css";

interface SegmentGroupProps {
  selectedSegment: string;
  onChange: (segment: string) => void;
}

export default function SegmentGroup({
  selectedSegment = "my-team",
  onChange,
}: SegmentGroupProps) {
  const segments = [
    {
      id: "my-team",
      label: "A minha equipa",
      icon: <StarOutlined />,
    },
    {
      id: "evaluated-by-team",
      label: "Avaliados pela minha equipa",
      icon: <FileTextOutlined />,
    },
    {
      id: "all-employees",
      label: "Todos os colaboradores",
      icon: <TeamOutlined />,
    },
  ];

  return (
    <div className={styles.container}>
      {segments.map((segment) => (
        <button
          key={segment.id}
          className={`${styles.segment} ${
            selectedSegment === segment.id ? styles.active : ""
          }`}
          onClick={() => onChange(segment.id)}
          type="button"
        >
          <span className={styles.icon}>{segment.icon}</span>
          <span className={styles.label}>{segment.label}</span>
        </button>
      ))}
    </div>
  );
}
